import CSS from "csstype";
import React from "react";
import { StateProps } from "./Center";
import { getLatestTurnDisplay } from "./turnDisplay";

type RightTurnSignalProps = StateProps & {
  hideSignal: boolean;
};

export const RightTurnSignal: React.FC<RightTurnSignalProps> = ({ state, hideSignal }) => {
  if (hideSignal) {
    return null;
  }

  if (state.position % 3 === 2 && state.turn === 0 && state.landlordHandID === null) {
    return (
      <div style={rightTurnSignal}>
        <span>{state.shownCard.value}</span>
      </div>
    );
  }

  const latestTurn = getLatestTurnDisplay(state);
  if (latestTurn?.actor !== "right") {
    return null;
  }

  return (
    <div style={rightTurnSignal}>
      <span>{latestTurn.action === "pass" ? "pass" : "\u2190"}</span>
    </div>
  );
};

const rightTurnSignal: CSS.Properties = {
  position: "absolute",
  top: "50%",
  right: "25%",
  transform: "translateX(-50%)",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.5em",
};
